export const path = "/compao-brand";
export const component = () => import("./index.jsx");
export const enabled = false;
export const sidebar = {
  title: "COMPAO BRANDS",
  section: "COMPAO",
  group: null,
  order: 4,
  roles: [
    "Authenticated",
    "design",
    "design-roundler",
    "aluna",
  ],
};
